import { API, authClient } from "../index";

// Get all countryes
export const getCountries = () => {
  return authClient().get(`${API}/country/?getDisabled=true`);
};

// Get country by id
export const getCountryById = (id) => {
  return authClient().get(`${API}/country/${id}`);
};

// Delete country
export const deleteCountry = (id) => {
  return authClient().delete(`${API}/country/${id}`);
};

// Create country
export const postCountry = async (country) => {
  return authClient().post(`${API}/country`, country);
};

// Update country
export const updateCountry = async (id, country) => {
  return authClient().put(`${API}/country/${id}`, country);
};

// Change status country
export const changeStatusCountry = async (id, active) => {
  return authClient().put(`${API}/country/change-status/${id}`, { active });
};
